import { InputLabel } from "~/common/mui";
import { type MouseEvent, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { SearchDisplayMode as SearchDisplayMode } from "~/features/search/models/models";

import { ToggleButton, ToggleButtonGroup } from "~/common/mui/Button/ToggleButton";

type DisplayModeButtonListProps = {
  className?: string;
  showSeriesTree?: boolean;
  showTechnical?: boolean; // temporary
  displayMode: SearchDisplayMode;
  setDisplayMode: (mode: SearchDisplayMode, e: MouseEvent) => void;
};

export const DisplayModeButtonList = ({
  className,
  showSeriesTree,
  showTechnical = true,
  displayMode,
  setDisplayMode,
}: DisplayModeButtonListProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <InputLabel shrink>{t("feature.toggle.searchPageLayout.name")}</InputLabel>
      <ToggleButtonGroup
        fullWidth
        className={className}
        value={displayMode}
        showCheckmarks={true}
        onClick={(e) => setDisplayMode((e.target as HTMLElement).getAttribute("value")! as SearchDisplayMode, e)}
      >
        <ToggleButton value={SearchDisplayMode.LIST} data-test-id={"switch-list-view"}>
          {t("feature.toggle.searchPageLayout.list")}
        </ToggleButton>
        {showTechnical && (
          <ToggleButton value={SearchDisplayMode.TABULAR} data-test-id={"switch-tabular-view"}>
            {t("feature.toggle.searchPageLayout.table")}
          </ToggleButton>
        )}
        {showSeriesTree && (
          <ToggleButton value={SearchDisplayMode.SERIES_TREE} data-test-id={"switch-series-view"}>
            {t("feature.toggle.searchPageLayout.seriesTree")}
          </ToggleButton>
        )}
      </ToggleButtonGroup>
    </div>
  );
};

export const DisplayModeButton = ({
  children,
  dataTestId,
  mode,
}: {
  dataTestId: string;
  mode: SearchDisplayMode;
  children?: ReactNode;
}) => {
  return (
    <ToggleButton value={mode} data-test-id={dataTestId}>
      {children}
    </ToggleButton>
  );
};

DisplayModeButton.List = () => (
  <DisplayModeButton dataTestId={"switch-list-view"} mode={SearchDisplayMode.LIST}>
    Simple
  </DisplayModeButton>
);
DisplayModeButton.Tabular = () => (
  <DisplayModeButton dataTestId={"switch-tabular-view"} mode={SearchDisplayMode.TABULAR}>
    Technical
  </DisplayModeButton>
);
DisplayModeButton.SeriesTree = () => (
  <DisplayModeButton dataTestId={"switch-series-view"} mode={SearchDisplayMode.SERIES_TREE}>
    Series tree
  </DisplayModeButton>
);
